export default "__VITE_ASSET__0ee7f631__"